import { graphql } from "gatsby"
import React from "react"
import { useTranslation } from "react-i18next"
import Layout from "../components/layout"
import Seo from "../components/seo"

const IndexPage = () => {
  const { t } = useTranslation()

  return (
    <Layout page="home">
      <Seo title={t("Home.name")} />
      <div className="page_container home">
        <h1 className="home__title">Correo Saliente</h1>
        <h3 className="home__subtitle">cello & guitar</h3>
      </div>
    </Layout>
  )
}

export default IndexPage

export const query = graphql`
  query($language: String!) {
    locales: allLocale(filter: { language: { eq: $language } }) {
      edges {
        node {
          ns
          data
          language
        }
      }
    }
  }
`
